export default {
	tm:'ThisMemo',
	qjt:'QiuJunTian',
	amap:'Amap',
	copyright:'©@year ThisMemo·QiuJunTian',
	username:'Account',
	nickname:'Nickname',
	password:'Password',
	email:'Email',
	wechat:'Wechat',
	registertime:'Register Time',
	verifyCode:'Code',
	terms:"Terms",
	contactUs:"Contact Us",
	contactUsText:"Please send email to ",
	user:"ThisMemo User",
	space:" ",
	loading:"Loading...",
	hello:{
		morning:'Good Morning, @nickname',
		afternoon:'Good Afternoon, @nickname',
		evening:'Good Evening, @nickname',
		midnight:'Time to Sleep, @nickname',
		slogan1:'Though Life Is Short, Memory Is Lasting',
		slogan2:'Memory Is The Most Beautiful Legend',
		slogan3:'I Came, I Known You',
		slogan4:'There\'s Always This Memo With You',
		slogan5:'Paradise Is Just A Few Steps Away',
		slogan6:'Meeting Again With You',
	},
	sloganNum:'6',
	footprint:{
		fp:'Footprint',
		longitude:'Longitude',
		latitude:'Latitude',
		scale:'Scale',
		address:'Address',
		addressEmpty:'Address Empty',
		note:'Note',
		noteInputTip:'Note Counting:',
		noteEmpty:'Note Empty',
		time:'Time',
		timeFormat:'MM/DD/YYYY HH:mm:ss',
		icon:'Icon',
		empty:'Footprint Empty',
	},
	icon:{
		all:'All',
		cluster:'Footprints\' Box',

		default:'Default',
		note:'Note',
		family:'Family',
		love:'Love',
		friend:'Friend',
		pet:'Pet',
		workf:'Work(Female)',
		workm:'Work(Male)',
		student:'Student',

		food:'Food',
		travel:'Travel',
		photo:'Photo',
		shopping:'Shopping',
		amusement:'Amusement',
		sport:'Sport',

		special:'Special',
		positive:'Positive',
		negative:'Negative',

		jnq:'Will Be Young',
	},
	btn:{
		close:'Close',
		return:'Return',
		returnLast:'Last Page',
		returnIndex:'Index',
		top:'Back to Top',
		login:'Login',
		bind:'Bind',
		unbind:'Unbind',
		logout:'Logout',
		signup:'Signup',
		forget:'Forget',
		record:'Record',
		edit:'Edit',
		delete:'Delete',
		modify:'Modify',
		share:'Share',
		shareEnd:'Close',
		reset:'Reset',
		sendLink:'Send Link',
		change:'Change',
		send:'Send',
		second:'s',
		relocate:'Relocate',
		mapFull:'Map Full',
		mapWindow:'Map Window',
	},
	form:{
		usernameSub:"For login, 6-15 & English Uppercases, Lowercases, Numbers.",
		passwordSub:"For login, 6-15 & English Uppercases, Lowercases, Numbers.",
		repasswordSub:"Enter again.",
		nicknameSub:"For display, 1-10 & Chinese(Simplified/Traditional), English Uppercases, Lowercases, Numbers, Minus, Underline.",
		emailSub:"For receiving account security information and resetting password",
		verifyCodeSub:"8 Digit Code",
		shareTitleSub:"Share Title(Can be empty), 1-10 & Chinese(Simplified/Traditional), English Uppercases, Lowercases, Numbers, Minus, Underline.",

		nullError:"This item cannot be empty.",
		lengthError:"The number of characters should be between @min and @max.",
		lengthOnlyError:"The number of characters should be @length.",
		n0Error:"Limited to Numbers.",
		Aa0Error:"Limited to English Uppercases, Lowercases, Numbers.",
		Aa0ZhZhtUDError:"Limited to Chinese(Simplified/Traditional), English Uppercases, Lowercases, Numbers, Minus, Underline.",
		emailError:"The mailbox format is incorrect.",
		sameError:"Different with @feild, please re-enter.",
		repeatError:"@feild has been occupied, please modify.",
	},
	_login:{
		title:'Login',
	},
	_signup:{
		title:'Signup',
	},
	_forget:{
		title:'Forget',
	},
	_index:{
		title:'Index',
	},
	_record:{
		title:'Record',
		info:'Info',
		selectIcon:'Icon',
		inputNote:'Note (Can be empty)',
	},
	_review:{
		title:'Review',

		review:'Review',
		map:'Map',

		mapsettings:'Map Settings',

		mapcluster:'Footprint Cluster',
		mapclustertips:'Turning off clustering may reduce review performance while footprints were too much.',

		mapstyle:'Map Style',
		mapdefault:'Default',
		maproad:'Roadnet',
		mapsat:'Satellite',
		mapsatroad:'Satellite & Roadnet',
		mapgoogle:'Google Default',
		mapgooglegeo:'Google Geograph',
		mapgooglesat:'Google Satellite',
		mapstamentoner:'Stamen Toner',
		mapstamenwatercolor:'Stamen Watercolor',

		detail:'Detail',  
		modifyIcon:'Modify Icon',
		modifyNote:'Modify Note',
		openedBy:'Open In Navigation Application',

		search:'Search Footprints',
		searchPlaceHolder:'Enter relevant information and divide keywords with spaces',
		searched:'Searched @count Footprint(s)',

		shareTip:'Click Footprints to Select\nThen click Share Button',
		shareSelected:'Selected',
		shareSelectedRepeat:'This Footprint Have Been Selected',
	},
	_shareFoorprints:{
		title:'FootPrint Share',
	},
	_achievement:{
		title:'Achievement',

		all:'All',
		fp:'Footprint',
		china:'China',
		world:'World',
		special:'Special',
		achi:' Achievements',

		empty:'Achievements Empty',

		getAchi:'Got New Achievements',
		getSpecial:'Got at ',
		notGetSpecial:'Not Got Yet',

		mostRecord:'Most Recorded ',
		mostActive:'Most Actived ',
	},
	share:{
		footprint:'FootPrint Share',
		achievement:'Achievement Share',
		sharedBy:'Shared By ',
		shareS:'\'s',
		join:'Scanning qrcode to follow the Wechat Public or Click',
	},
	_sharefoorprints:{
		title:'FootPrint Share',
	},
	_shareAchievement:{
		title:'Achievement Share',

		overview:'Overview',
		overview1:'Since「@time」, I have recorded footprints by',
		overviewPrefix:'',
		overviewUnit:'In Total',
	},
	_settings:{
		title:'Settings',
		settings:'Settings',
		shared:'Shared',
		unrecorded:'Unrecorded',

		info:'Account Info',
		language:'設置語言',
		resetPassword:'Password',
		changeMail:'Email',
		unbindWechat:'Unbind Wechat',
		unbindEmpty:'Not Bind Wechat Temporarily',

		submit:'Submit',
		share:'Share',
		option:'Option',
		listEmpty:'List Empty',
		sharedFp:' Fps',
		pageView:' Views',
	},
	_resetPassword:{
		title:'Reset Password',
		newPassword:'New Password',
	},
	_changeMail:{
		title:'Change Mail',
		newMail:'New Mail',
	},
	_wechatBind:{
		title:'Bind Wechat',
		tips:'You can complete the binding by logging in your account here.',
	},
	_about:{
		title:'About & Help',
		slogan:'It\'s okay. \nYou have a completely new ThisMemo.',
		wechat:'After the account binded with Wechat, you can use Wechat to enter to ',

		recordSlogan:'Create your own unique coordinates in time and space',
		recordHelp1:'Click the following icon on the index page to enter this function.',
		recordHelp2:'This function needs to turn on the positioning function of GPS, and agree to use the positioning function (some desktop browsers may not be able to locate).',
		recordHelp3:'If the dialog box pops up, please select "allow"; Otherwise, program will not be able to locate. When the footprint icon is displayed on the map, the positioning is successful.',
		recordHelp4:'There may be two buttons on the lower right corner of the map, with the following functions:',
		recordHelp41:'Sumbited by Wechat will not appear',
		recordHelp5:'Select footprint icon and fill in footprint note (note can be blank).',
		recordHelp61:'Click ',
		recordHelp62:' on the bottom of the page, record the current footprint.',
		
		reviewSlogan:'Looking back and sharing',
		reviewHelp1:'Click the following icon on the index page to enter this function.',
		reviewHelp2:'Footprint Details:Click the footprint icons on map to enter the Footprint Details.',
		reviewHelp3:'Modify Footprint:Footprint Details → Edit → Modify content → Modify.',
		reviewHelp4:'Delete Footprint:Footprint Details → Edit → Delete.',
		reviewHelp5:'Search Footprints:Click the following icon to enter, input relevant information to search, and use the space to divide keywords (click the footprints\' icon to add icon search conditions).',
		reviewHelp6:'Map Settings:Click the following icon to enter, and you can set map displaying preferences.',
		reviewHelp7:'Share Footprints:Click the following icon to enter.',

		achiSlogan:'「Get my own medals」',
		achiHelp1:'Click the following icon on the index page to enter this function. The system will automatically display the footprint achievements you have got.',
		achiHelp2:'Share Achievements:Click the following icon to enter.',

		settingSlogan:'Travel around the world with my backpack and pride',
		settingHelp1:'Click the following icon on the index page to enter this function.',
		settingHelp2:'Settings:You can set the language, reset the password, et cetera.',
		settingHelp3:'Shared:Manage your own shared pages of footprints and achievements.',
		settingHelp31:'View shared pages',
		settingHelp4:'Unrecorded:Manage your own submitted footprints that have not been recorded.',
		settingHelp41:'Click to record the footprints',

		wechatHelp1:'ThisMemo will not ask for your Wechat account and password for any reason, and be careful not to be cheated.',
		wechatHelp2:'Benefits',
		wechatHelp211:'Positioning',
		wechatHelp212:'More accurate\nFaster',
		wechatHelp221:'Security',
		wechatHelp222:'No password\nFlexible & Secure',
		wechatHelp231:'Elastic Record',
		wechatHelp232:'Submit at once\nRecord one by one',
		wechatHelp3:'How To Bind',
		wechatHelp31:'First of all, you must have an account for this account. If not, please Signup.',
		wechatHelp32:'Secondly, follow this wechat public platform:search for 「thismemo」 or scan the Qrcode below.',
		wechatHelp33:'Then, enter the public account and click 「绑定微信」 at the bottom of the page.',
		wechatHelp34:'On the page, enter the account number and password. After the prompt is successful, you can use wechat to log in and operate the record.',
		wechatHelp4:'How To Unbind',
		wechatHelp41:'Log in ThisMemo in any way, Index → Settings → Unbind.',

		others:'Others',
		acknowledgement:'Thanks for「林老北」、「哲仔」、「林大雨」、「饺子」',
	},
	_404:{
		title:'404',
		tip:'The page no longer exists.\nEveryone is looking for it.',
	},
	_notice:{
		title:'Notice',
		AUTH_FAILED:'The link is expired, please resend in Wechat.',
		BIND_WECHAT_SUCCESS:'Bind successfully. You can close the page and use functions normally in Wechat.',
		ALREADY_BIND_WECHAT:'Your Wechat has been binded with to another account, please unbind and try again.',
	},
	BACKENDMSG:{
		undefined:'Unknown error, please try again later.',
		UNKNOWN_ERROR:'Unknown error, please try again later.',
		WRONG_SESSION:'Login expired, please re-login.',
		WRONG_TOKEN:'Login expired, please re-login.',
		DIFFERENT_TOKEN:'Login expired, please re-login.',
		LOGIN_SUCCESS:'Login successfully.',
		LOGIN_WRONG_USERNAME:'Username wrong.',
		LOGIN_WRONG_PASSWORD:'Password wrong.',
		LOGOUT_SUCCESS:'Logout successfully.',
		RFP_M_Q:'Confirm to modify?',
		RFP_M_END_Q:'Footprint was change, confirm to quit?',
		RFP_M_FAIL:'Fail to modify, please try again later.',
		RFP_M_SAME:'Footprint is not change, cannot modify.',
		RFP_M_SUCCESS:'Modifiy successfully.',
		RFP_D_Q:'Deletion is unrecoverable, confirm to delete?',
		RFP_D_FAIL:'Fail to delete please try again later.',
		RFP_D_SUCCESS:'Delete successfully.',
		RFP_SH_FAIL:'Selected empty, cannot share.',
		RFP_SH_SUCCESS:'Generating share page, please wait for jumping.',
		RECFP_LOCATE_ERROR:'Fail to get position. Please check network, GPS settings, clicking OK to agree with getting position info.\n Then, clicking Relocate button to try again.',
		RECFP_LOCATE_NOT_HTTPS:'Fail to get position. Please contact administrator.',
		RECFP_LOCATE_PERMISSION_DENIED:'Fail to get position. Please allow the permission for Geolocation.',
		RECFP_LOCATE_POSITION_UNAVAILABLE:'Fail to get position. Location information is unavailable.',
		RECFP_LOCATE_TIMEOUT:'Fail to get position. The request to get location timed out.',
		RECFP_LOCATE_UNKNOWN_ERROR:'Fail to get position. An unknown error occurred.',
		RECFP_RELOCATE:'Relocating, please try again later.',
		RECFP_REC_FAIL:'Fail to record, please try again later.',
		RECFP_REC_SUCCESS:'Record successfully.',
		ACHI_FAIL:'Fail to load achievements, please try again later.',
		ACHI_SUCCESS:'Load achievements successfully.',
		U_SETLANG_SUCCESS:'Save language preferences successfully.',
		U_SETLANG_FAIL:'Fail to save language preferences, please try again later.',
		U_UNBIND_WECHAT_Q:'Confirm to unbind?',
		U_LIST_D_Q:'Deletion is unrecoverable, confirm to delete?',
		SIGNUP_SEND_WRONG_EMAIL:'Please enter the correct format of email address.',
		SIGNUP_SEND_1MIN:'Please try sending again in @sec seconds.',
		SIGNUP_SUCCESS:'Signup successfully.',
		SEND_EMAIL_SUCCESS:'The information has been sent successfully to @email. Please check your inbox and spam.',
		SEND_EMAIL_FAIL:'Fail to send email, please try again later.',
		SEND_EMAIL_EMPTY:'Your account has not been set email yet. Please contact us by clicking the button at the bottom of the page to set it.',
		FORM_WRONG:'Please check the error information you inputted',
		FORM_VC_SEND_SUCCESS:'The code has been sent successfully to @email. Please check your inbox and spam.',
		FORM_VC_WRONG:'The code is wrong, please check agian.',
		FORM_VC_EXPIRED:'The code is expired, please resend.',
		RESET_EXPIRED:'The link is expired, please resend.',
		RESET_UNFOUND:'The link does not exist, please resend.',
		RESET_SUCCESS:'Change successfully.',
		RESET_P_SAME:'Same passwords, please enter a different one.',
		RESET_MAIL_SAME:'Same emails, please enter a different one.',
		RESET_LOGIN_FORGET_UNFOUND_USERNAME:'Wrong username, please re-enter.',
		RESET_LOGIN_FORGET_EMAIL_UNSAME:'The email is different with the one you signup, please re-enter.',
		UNBIND_SUCCESS:'Unbind successfully.',
		NOT_BIND_WECHAT:'Not Bind Wechat Temporarily.',
		BIND_WECHAT_UNFOUND:'The link is expired, please resend in Wechat.',
		TAKEN_BIND_WECHAT:'Your Wechat has been binded with to another account, please unbind and try again.',
		ALREADY_BIND_WECHAT:'Your account has been binded with to another Wechat, please unbind and try again.',
		BIND_SUCCESS:'Bind successfully. You can use functions normally in Wechat.',
		REDIRECT_UNFOUND:'Link expired.',
	}
}



// WEBPACK FOOTER //
// ./src/lang/en.js